import { render, staticRenderFns } from "./SetOrder.vue?vue&type=template&id=3424db01&scoped=true&"
import script from "./SetOrder.vue?vue&type=script&lang=js&"
export * from "./SetOrder.vue?vue&type=script&lang=js&"
import style0 from "./SetOrder.vue?vue&type=style&index=0&id=3424db01&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3424db01",
  null
  
)

export default component.exports